import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import DestroyMixin from '../../destroy-mixin';
import { CONTROL_CONTAINER_PROVIDER } from '../../control-utils';
import { Item } from '../../models/item';
import { EstruturaComponent, setReadonlyValue, toItem } from '../../estrutura-component-utils';
import { ConsultaSiapeService, Orgao } from '../../../../services/consulta-siape.service';
import { of } from 'rxjs';

@Component({
    selector: 'frq-select-orgao',
    templateUrl: './select-orgao.component.html',
    styleUrls: ['./select-orgao.component.scss'],
    viewProviders: [CONTROL_CONTAINER_PROVIDER]
})
export class SelectOrgaoComponent extends DestroyMixin(Object) implements EstruturaComponent, AfterViewInit {
    @Input() formControlName = 'codigoOrgao';
    @Input() required = false;
    @Input() readonly = false;
    @Input() bloquearQuandoUnicoItem = true;
    @Output() changeCallback? = new EventEmitter<any>();

    @ViewChild(NgControl, { static: true }) select!: NgControl;

    originalReadonlyValue;
    orgaosItens;

    constructor(
        private estruturaService: ConsultaSiapeService,
        public element: ElementRef<HTMLElement>,
        private segurancaService: SegurancaService
    ) {
        super();
        this.originalReadonlyValue = this.readonly;
    }

    onChangeCallback() {
        //console.debug("onChangeCallback >> " + this.changeCallback);
        this.changeCallback.emit();
    }

    ngAfterViewInit(): void {
        //Se tiver apenas 1 item, bloqueia o campo
        this.estruturaService
            .listOrgaos()
            .pipe(toItem(this))
            .subscribe(itens => {
                this.orgaosItens = itens;
                if (this.orgaosItens && this.orgaosItens.length === 1) {
                    if (this.bloquearQuandoUnicoItem) {
                        setReadonlyValue(this, of(this.orgaosItens[0].id));
                    } else {
                        this.readonly = this.originalReadonlyValue;
                        if (!this.select.control.value) {
                            this.select.control.setValue(this.orgaosItens[0].id);
                        }
                    }
                } else {
                    this.readonly = this.originalReadonlyValue;
                    setReadonlyValue(this, of(null));
                }
            });
    }
}
